import { Button, Typography, TypographyVariant } from '@mui/material';
import React from 'react';
import GameSettings from '../../Settings/GameSettings';

interface MenuButtonProps {
    onClick: React.MouseEventHandler | undefined;
    text: string;
    buttonWidth: string | Record<string, string>;
    textSize: TypographyVariant;
    background: string;
    hoverBackground: string;
    dynamicCursor: boolean;
    staticCursorImage: string;
    disabled: boolean;
}

const MenuButton = (props: MenuButtonProps) => {
    const gameSettings = new GameSettings();

    return (
        <Button
            onClick={props.onClick}
            sx={{
                width: props.buttonWidth,
                height: { xs: '52px', sm: 'clamp(28px, 4vw, 48px)' },
                minWidth: 'fit-content',
                paddingX: { xs: '16px', sm: 'clamp(8px, 2vw, 24px)' },
                backgroundImage: props.background,
                backgroundSize: '100% 100%',
                backgroundPosition: 'left',
                backgroundRepeat: 'no-repeat',
                '&:hover': {
                    backgroundImage: props.hoverBackground || props.background
                },
                pointerEvents: props.disabled ? 'none' : 'auto',

                cursor: props.dynamicCursor ? `${gameSettings.getRandomCursor()}, auto` : `${props.staticCursorImage}, auto`
            }}
        >
            <Typography variant={props.textSize} color="black" textTransform="none" sx={{ fontSize: { xs: '1.05rem', sm: 'clamp(0.8rem, 2.2vw, 1.5rem)' }, whiteSpace: 'nowrap' }}>
                {props.text}
            </Typography>
        </Button>
    );
};

export default MenuButton;
